export type Theme = 'light' | 'dark';

/** --canvas светлой/тёмной темы (client/src/styles/tokens.css). Мета-тег
 *  theme-color и манифест не читают CSS-переменные, поэтому это литералы —
 *  исключение, записанное в client/docs/design-system.md. Меняешь --canvas —
 *  меняй и здесь, и в client/index.html. */
export const THEME_COLOR: Record<Theme, string> = { light: '#FFFFFF', dark: '#0E1017' };
